"use client";

import {memo, useState} from "react";
import {useTranslation} from "react-i18next";
import {Tooltip, TooltipContent, TooltipTrigger} from "@/components/ui/tooltip";
import Icon, {ICON_TYPE} from "@/components/library/Icon";
import GailGptMemoryDialog from "./GailGptMemoryDialog";

type MemoryComposerButtonProps = Readonly<{
   disabled?: boolean;
}>;

function MemoryComposerButton({disabled = false}: MemoryComposerButtonProps) {
   const {t} = useTranslation("ask");
   const [open, setOpen] = useState(false);
   const label = t("memory.open");

   return (
      <>
         <Tooltip delayDuration={0}>
            <TooltipTrigger asChild>
               <button
                  type="button"
                  onClick={() => setOpen(true)}
                  disabled={disabled}
                  aria-label={label}
                  data-testid="memory-composer-button"
                  className="h-8 w-8 p-0 shrink-0 rounded-lg bg-transparent text-800 hover:bg-200 disabled:opacity-50 flex items-center justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-300 transition-colors duration-200"
               >
                  <Icon icon="book" type={ICON_TYPE.LIGHT} />
               </button>
            </TooltipTrigger>
            <TooltipContent side="bottom">{label}</TooltipContent>
         </Tooltip>
         <GailGptMemoryDialog open={open} onOpenChange={setOpen} />
      </>
   );
}

// The composer re-renders on every keystroke; this control does not depend on the draft.
export default memo(MemoryComposerButton);
